module.exports = __webpack_public_path__ + "static/media/warehouse-alt.22253337.svg";